import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cheaseed-core-cheaseed-core',
  template: `
    <p>
      cheaseed-core works!
    </p>
  `,
  styles: [
  ]
})
export class CheaseedCoreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
